import { setLocale } from '@umijs/max';

export const LOCALE_OPTIONS = [
  { value: 'zh-CN', label: '中文', shortLabel: '中' },
  { value: 'en-US', label: 'English', shortLabel: 'EN' },
  { value: 'ja-JP', label: '日本語', shortLabel: '日' },
] as const;

export type SupportedLocale = (typeof LOCALE_OPTIONS)[number]['value'];

const SUPPORTED_LOCALE_SET = new Set<SupportedLocale>(
  LOCALE_OPTIONS.map((item) => item.value),
);

export const normalizeLocale = (lang?: string): SupportedLocale => {
  if (lang && SUPPORTED_LOCALE_SET.has(lang as SupportedLocale)) {
    return lang as SupportedLocale;
  }
  return 'zh-CN';
};

export const getLocaleOption = (lang?: string) =>
  LOCALE_OPTIONS.find((item) => item.value === normalizeLocale(lang)) ??
  LOCALE_OPTIONS[0];

const syncHomepageLanguage = (locale: SupportedLocale) => {
  try {
    const key = 'chuhai7.home.language';
    const previous = window.localStorage.getItem(key);
    const language = {
      'zh-CN': previous === 'zh-TW' ? 'zh-TW' : 'zh-CN',
      'en-US': 'en',
      'ja-JP': 'ja',
    }[locale];
    window.localStorage.setItem(key, language);
  } catch {
    // A homepage preference must not prevent switching the app language.
  }
};

export const applyLocaleChange = (lang: string) => {
  const nextLocale = normalizeLocale(lang);

  if (typeof window === 'undefined') {
    setLocale(nextLocale, false);
    return;
  }

  try {
    if (navigator.cookieEnabled && typeof window.localStorage !== 'undefined') {
      window.localStorage.setItem('umi_locale', nextLocale);
      syncHomepageLanguage(nextLocale);
      window.location.reload();
      return;
    }
  } catch (error) {
    // Ignore storage errors and fall back to Umi's runtime locale switch.
  }

  setLocale(nextLocale, true);
};
